// import store from "@/state/store";

export default [
  {
    path: "/",
    name: "default",
    meta: {
      title: "Formulir Pelamar",
      authRequired: true,
    },
    component: () => import("../views/hr-form/index.vue"),
  },
  {
    path: "/success",
    name: "hrform-success",
    meta: {
      title: "Formulir Berhasil Terkirim",
    },
    component: () => import("../views/hr-form/success.vue"),
  },
  {
    path: "/upload-documents",
    name: "upload-documents",
    meta: {
      title: "Portal Unggah Dokumen Pelamar",
    },
    component: () => import("../views/hr-form/upload-documents.vue"),
  },
];
